import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles, categories } from '@/mocks/data';

const nonFeaturedCategories = categories.filter((c) => c.slug !== 'all');

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredArticles = slug
    ? articles.filter((a) => a.category === slug)
    : articles;

  const pageTitle = category ? `${category.name} - 淫乱小镇` : '故事分类 - 淫乱小镇';
  const pageDescription = category
    ? `浏览淫乱小镇${category.name}分类下的所有原创故事。${category.name}类故事汇集了小镇中最精彩的情感与悬疑内容，每日更新。`
    : '浏览淫乱小镇所有分类的原创故事。都市情感、悬疑剧情、人物传奇、深夜物语、小镇秘闻——总有一个故事触动你的心。';

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: pageTitle,
    description: pageDescription,
    url: `https://hzhgjs.cn/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '淫乱小镇',
      url: 'https://hzhgjs.cn',
    },
  };

  if (!category && slug) {
    return (
      <>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-background-50">
          <Navbar />
          <main className="flex-1 flex items-center justify-center pt-16">
            <div className="text-center">
              <h1 className="font-heading text-2xl text-foreground-900 mb-3">分类未找到</h1>
              <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                返回首页
              </Link>
            </div>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

      <div className="min-h-screen flex flex-col bg-background-50">
        <Navbar />

        <main className="flex-1 pt-20">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            {/* Breadcrumb */}
            <div className="mb-4">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: category?.name || '全部故事' },
                ]}
              />
            </div>

            {/* Page Header */}
            <div className="mb-6">
              <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
                {category?.name || '全部故事'}
              </h1>
              <p className="text-sm text-foreground-600 max-w-2xl">
                {category
                  ? `浏览${category.name}分类下的所有精彩故事，发现小镇中最动人的篇章。`
                  : '浏览淫乱小镇所有分类的原创故事，发现最触动心灵的文字。'}
              </p>
            </div>

            {/* Category Tabs */}
            <div className="mb-8">
              <CategoryTabs
                categories={nonFeaturedCategories}
                activeSlug={slug || ''}
              />
            </div>

            {/* Article Grid */}
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-14">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.slug} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-600 mb-3">该分类下暂无文章</p>
                <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}